/*
 * 功能模块的颜色变量配置
 */

import { ThemeColors } from '..';

export const projectsColors: ThemeColors = {
  color: {
    'project-upgrade-tip-color': 'var(--project-upgrade-tip-color)',
  },
  backgroundColor: {
    'projects-project-img-bg': 'var(--projects-project-img-bg)',
    'projects-project-card-bg': 'var(--projects-project-card-bg)',
    'projects-video-cover-bg': 'var(--projects-video-cover-bg)',
    'project-input-bg': 'var(--project-input-bg)',
    'project-card-input-bg': 'var(--project-card-input-bg)',
    'project-upgrade-tip-bg': 'var(--project-upgrade-tip-bg)',
  },
  borderColor: {},
};
